import React, { useState, useContext, useEffect } from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonButtons, IonButton, IonMenuButton, IonModal, IonLabel } from '@ionic/react';
import { IonGrid, IonRow, IonCol, IonInput } from '@ionic/react';


import '../../css/layout.css';
import { App_Header } from '../components/App_Header';
import { ProfileSetting_ContactInfo } from '../components/ProfileSetting_ContactInfo';
import { ProfileSetting_PaymentInfo } from '../components/ProfileSetting_PaymentInfo';
import { ProfileSetting_EmployeePayInfo } from '../components/ProfileSetting_EmployeePayInfo';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

 export function Hotel_ProfileSetting() {


    let authenticated_Zasava_Context = useContext(Auth_Zasava_Context);


    const [acctID, setAcctID ] = useState(authenticated_Zasava_Context.acctID);
    const [employeeID, setEmployeeID ] = useState(authenticated_Zasava_Context.employeeID);
    const [schema, setSchemaName] = useState(authenticated_Zasava_Context.schema);
    let [baseURL, setBaseURL ] = useState(authenticated_Zasava_Context.baseURL);

    let [showContactInfoModal, setShowContactInfoModal] = useState(false);
    let [showPaymentInfoModal, setShowPaymentInfoModal] = useState(false);
    let [showEmployeePayInfoModal, setShowEmployeePayInfoModal] = useState(false);

    let [companyRole, setCompanyRole] = useState(null);
    let [hireDate, setHireDate] = useState(null);
    let [hourlyPay, setHourlyPay] = useState(null);
    let [jobFunction, setJobFunction] = useState(null);

    useEffect(() => {

        let formData = new FormData();
        formData.append('Tracker', 74800);
        formData.append('user', acctID);
        formData.append('xEmployeeID', employeeID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setCompanyRole(cols[1]);
                    setHireDate(cols[6]);
                    setHourlyPay(cols[7]);
                    setJobFunction(cols[8]);
                }
        })

    }, []);


    //const xTracker = this.state.Tracker;
    //const xUsername = this.state.pUsername;
    //const xPassword = this.state.pPassword;

    //alert("In Profile Setting");
    //alert(this.state.schema);

    return (
        <React.Fragment>

            <App_Header></App_Header>
            <IonContent className='appContent'>
                <IonGrid>
                            <IonRow>
                                <IonCol> Employee ID: </IonCol>
                                <IonCol> {employeeID} </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol> Company Role: </IonCol>
                                <IonCol> {companyRole} </IonCol>
                            </IonRow>                                
                            <IonRow>
                                <IonCol> Hire Date: </IonCol>
                                <IonCol> {hireDate} </IonCol>
                            </IonRow>                                
                            <IonRow>
                                <IonCol> Bi/Weekly Pay: </IonCol>
                                <IonCol> {hourlyPay} </IonCol>
                            </IonRow>                                
                            <IonRow>
                                <IonCol> Job Function: </IonCol>
                                <IonCol> {jobFunction} </IonCol>
                            </IonRow>
                </IonGrid>
                <IonGrid>
                    <IonRow>
                        <IonCol size='6'>
                            <h3 >Contact Info</h3>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton onClick={() => setShowContactInfoModal(true)}> View  </IonButton>
                        </IonCol>           
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h3 >Payment Info</h3>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton onClick={() => setShowPaymentInfoModal(true)}> View  </IonButton>
                        </IonCol>           
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h3 >Employee Pay</h3>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton onClick={() => setShowEmployeePayInfoModal(true)}> View  </IonButton>
                        </IonCol>           
                    </IonRow>
                </IonGrid>

                <ProfileSetting_ContactInfo openModal={ showContactInfoModal } closeModal={() => setShowContactInfoModal(false)}></ProfileSetting_ContactInfo>

                <ProfileSetting_PaymentInfo openModal={ showPaymentInfoModal } closeModal={() => setShowPaymentInfoModal(false)}></ProfileSetting_PaymentInfo>

                <ProfileSetting_EmployeePayInfo openModal={ showEmployeePayInfoModal } closeModal={() => setShowEmployeePayInfoModal(false)}></ProfileSetting_EmployeePayInfo>


            </IonContent>

        </React.Fragment>

    );
};



export default Hotel_ProfileSetting;